import {useRouter} from 'next/router';
import {ButtonGroup, ButtonGroupProps, IconButton} from '@chakra-ui/react';

import {BallIcon2 as BallIcon, ListIcon} from '@eksab/assets/icons';
import {getLanguage} from '@eksab/util/helpers';

import {useLineupStore} from './useLineupStore';

type Props = ButtonGroupProps;

export function GridListToggle(props: Props) {
  const {locale} = useRouter();
  const view = useLineupStore((state) => state.view);
  const setView = useLineupStore((state) => state.setView);
  return (
    <ButtonGroup
      isAttached
      variant="unstyled"
      borderWidth="1px"
      borderColor="black"
      borderRadius="sm"
      overflow="hidden"
      {...props}
    >
      <IconButton
        aria-label="Field view"
        icon={<BallIcon />}
        minW="40px"
        h="40px"
        onClick={() => setView('pitch')}
        bgColor={view === 'pitch' ? 'green.400' : 'unset'}
        borderRadius="none"
        borderEndWidth="1px"
        borderColor="black"
      />

      <IconButton
        aria-label="List view"
        onClick={() => setView('list')}
        bgColor={view === 'list' ? 'green.400' : 'unset'}
        icon={<ListIcon />}
        transform={`rotateY(${getLanguage(locale) === 'en' ? 1 : 0.5}turn)`}
        minW="40px"
        h="40px"
        borderRadius="none"
      />
    </ButtonGroup>
  );
}
